import { render, staticRenderFns } from "./PermissionSelectDrawer.vue?vue&type=template&id=2be9dc49&scoped=true&"
import script from "./PermissionSelectDrawer.vue?vue&type=script&lang=js&"
export * from "./PermissionSelectDrawer.vue?vue&type=script&lang=js&"
import style0 from "./PermissionSelectDrawer.vue?vue&type=style&index=0&id=2be9dc49&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9dc49",
  null
  
)

export default component.exports